import React from "react";
import { useLocation } from "react-router-dom";
import { UserStatus } from "../../../constants";
import { Col, Container, Label, Row } from "reactstrap";
import { CustomText } from "../../../components/CustomText";

import SubscriptionStatus from "../../../constants/SubscriptionStatus";
import { GetAudioById } from "../../../api/api.service";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { hasData, truncateFileName } from "../../../utils/commonUtils";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";
import APP_CONFIG from "../../../APP_CONFIG";

const AudioSoundscapeDetail = () => {
    const location = useLocation();

    // Extract the ID from the path (assuming the path is "/audio/singles/details/21")
    const soundscapesID = location.pathname.split("/").pop();

    let { useFetch } = useRequestProcessor();

    const { data, isLoading, isFetching } = useFetch(
        getKey([MODULE_KEYS.AUDIO_BY_ID], { soundscapesID }),
        async ({ signal }) =>
            await GetAudioById({
                Id: soundscapesID
            })
    );
    const thumbnail = data?.thumbnail;
    const croppedThumbnail = data?.croppedThumbnail;
    const audioURL = `${data?.audios?.[0]?.audioMedia?.location}${data?.audios?.[0]?.audioMedia?.thumbPath}`;
    const audio = data?.audios?.[0]?.audioMedia;

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <Container fluid className="py-4 audio-single-detail-container">
            <Row className="mb-4">
                <Col md="3">
                    <CustomText
                        title={"Title"}
                        description={data?.title || "-"}
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
                <Col md="3">
                    <CustomText
                        title="Sub Category"
                        description={
                            data?.albumLabels?.length
                                ? data.albumLabels
                                      .map((item) => item.label?.title)
                                      .filter(Boolean)
                                      .join(", ")
                                : "-"
                        }
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>
                <Col md="3">
                    <CustomText
                        titleClass="label-classes"
                        descClass="desc-classes"
                        description={data?.author?.name || "-"}
                        title={"Author"}
                    />
                </Col>
                <Col md="3">
                    <CustomText
                        titleClass="label-classes"
                        description={SubscriptionStatus.getDisplayTextKey(data?.tierType) || "N/A"}
                        title={"Audio Content"}
                        descClass={`status-common-class ${SubscriptionStatus.getLabelClass(
                            data?.tierType
                        )}`}
                    />
                </Col>
                {/* <Col md="3">
                    <CustomText
                        title={"Narrator"}
                        description={data?.narrator?.name || "-"}
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col> */}
            </Row>
            <Row className="mb-4">
                <Col md="3">
                    <CustomText
                        titleClass="label-classes"
                        descClass={`  ${
                            data?.status ? "status-common-class" : ""
                        } ${UserStatus.getLabelClass(data?.status)}`}
                        title={"Status"}
                        description={UserStatus.getDisplayTextKey(data?.status) || "N/A"}
                    />
                </Col>
            </Row>

            <Row className="my-2">
                <Col md="12">
                    <CustomText
                        titleClass="label-classes"
                        description={data?.audios?.[0]?.description || "-"}
                        title={"Description"}
                        descClass="desc-classes"
                    />
                </Col>
            </Row>

            <Row className="my-2">
                <Col md="12">
                    <CustomText
                        titleClass="label-classes"
                        description={data?.audios?.[0]?.completionMessage || "-"}
                        title={"Session Success Message"}
                        descClass="desc-classes"
                    />
                </Col>
            </Row>

            <Row className="px-4 my-2">
                <Col md={6}>
                    <p className="mb-2 input-label">{"Uploaded Audio"}</p>

                    <div className="uploaded-file-container  ">
                        <div className="file-preview ">
                            <audio controls className="uploaded-audio">
                                <source
                                    src={audioURL}
                                    type={`audio/${audio.extension || "mpeg"}`}
                                />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                        <div className="file-details">
                            <span className="file-name">
                                {truncateFileName(audio.name, 10) || "-"}
                            </span>
                            <span className="file-size">{`${audio.size} KB` || "-"}</span>{" "}
                        </div>
                    </div>
                </Col>
                <Col md={6}>
                    <p className="mb-2 input-label">{"Uploaded Thumbnail"}</p>
                    <div className="uploaded-file-container ">
                        <div className="file-preview">
                            <img
                                src={
                                    `${croppedThumbnail?.location}${croppedThumbnail?.thumbPath}` ||
                                    APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER
                                }
                                alt={croppedThumbnail?.name || "Thumbnail"}
                                className="uploaded-thumbnail"
                            />
                        </div>

                        <div className="file-details">
                            <span className="file-name">
                                {truncateFileName(croppedThumbnail?.name, 20) || "-"}
                            </span>
                            <span className="file-size">
                                {`${croppedThumbnail?.size} KB` || "-"}
                            </span>{" "}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="px-4 my-2">
                <Col md={12}>
                    <p className="mb-2 input-label">{"Uploaded Image"}</p>
                    <div className="uploaded-file-container ">
                        <div className="file-preview">
                            <img
                                src={
                                    `${thumbnail?.location}${thumbnail?.thumbPath}` ||
                                    APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER
                                }
                                alt={thumbnail.name || "Thumbnail"}
                                className="uploaded-thumbnail"
                            />
                        </div>

                        <div className="file-details">
                            <span className="file-name">
                                {truncateFileName(thumbnail?.name, 20) || "-"}
                            </span>
                            <span className="file-size">{`${thumbnail?.size} KB` || "-"}</span>{" "}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default AudioSoundscapeDetail;
